export const mdm = {
    headerTitle: 'MDM',
    route: 'mdm',
    pageTitle: 'MDM',
    related: [
      { route: 'jobverwaltung/jobs', menuTitle: 'Jobs ansehen' },
      { route: 'benutzerverwaltung/schularten', menuTitle: 'Schulen verwalten' },
      { route: 'benutzerverwaltung', menuTitle: 'Benutzerverwaltung' },
      { route: 'hub/settings', menuTitle: 'Hub verwalten' },
    ],
    cards: [
      {
        route: 'grundeinstellungen',
        icon: 'fas-tablet-screen-button-mdm',
        endpoint: '/api/mdm/settings',
        preHooks: {
          list: 'mdm_settings_preHook'
        },
        tag: 'paedml-card-mdm',
        category: 'MDM',
        menuTitle: 'Grundeinstellungen',
        pageTitle: 'paed.ML - MDM: MDM Grundeinstellungen',
        name: 'grundeinstellungen',
        contentTitle: 'Grundeinstellungen',
        prefix: 'grundeinstellungen',
        suffix: undefined,
        custom: {
          variant: 'settings'
        },
        table: {
          columns: [
            { title: 'FQDN-Adresse', name: 'externalServerUrl', col: 0, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'IP-Adresse', name: 'ipAddress', col: 1, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'IP-Adresse Datenbank', name: 'databaseIpAddress', col: 2, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'ProxyPass Parameter', name: 'remoteHost', col: 3, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'LDAP Server', name: 'ldapServer', col: 4, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'Email MDM Systemadministrator', name: 'administratorEmail', col: 5, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'MDM Dienstkonto', name: 'serviceAccountUsername', col: 6, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'Status', name: 'statusDP', col: 7, visible: true, searchable: false, printable: true, exportable: true },
            { title: 'Status', name: 'status', col: 8, visible: false, searchable: false, printable: false, exportable: false},
            { title: 'Lizenz', name: 'licenseModelNameDP', col: 9, visible: true, searchable: false, printable: true, exportable: true },
          ],
          data: {
            url: '',
            dataSrc: ''
          },
          custom: {
            pageLength: 10
          }
        }
      },
      {
        route: 'mdm',
        icon: 'fas-tablet-screen-button-mdm',
        endpoint: '/api/mdm',
        preHooks: {
          list: 'mdm_list_preHook'
        },
        tag: 'paedml-card-mdm',
        category: 'MDM',
        menuTitle: 'Schuleinstellungen',
        pageTitle: 'paed.ML - MDM: MDM Schuleinstellungen',
        name: 'mdm',
        contentTitle: 'Schuleinstellungen',
        prefix: 'mdm',
        suffix: undefined,
        custom: {
          variant: 'schooltype'
        },
        table: {
          columns: [
            { title: 'ID', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
            { title: 'Kürzel', name: 'name', col: 1 },
            { title: 'Name', name: 'description', col: 2 },
            { title: 'MDM Status', name: 'mdmSchoolStatus', col: 3, visible: true, searchable: false, printable: true, exportable: true},
            { title: 'status', name: 'status', col: 4, visible: false, searchable: false, printable: false, exportable: false},
          ],
          data: {
            url: '',
            dataSrc: ''
          },
          custom: {
            pageLength: 10
          }
        }
      }
    ]
  }
